var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cross",
    d: "M7.95867 7.97153H13.0341C13.2901 7.97146 13.5357 7.86967 13.7167 7.68856C13.8977 7.50744 13.9993 7.26185 13.9993 7.00579C13.9992 6.74973 13.8974 6.50419 13.7163 6.32318C13.5352 6.14217 13.2896 6.04052 13.0335 6.0406H7.95812L7.95867 0.965743C7.95867 0.709612 7.85692 0.463972 7.67581 0.28286C7.4947 0.101748 7.24906 0 6.99293 0C6.7368 0 6.49115 0.101748 6.31004 0.28286C6.12893 0.463972 6.02718 0.709612 6.02718 0.965743L6.02774 6.0406H0.952329C0.698459 6.04381 0.456075 6.14691 0.277686 6.32757C0.0992972 6.50823 -0.000732422 6.7519 -0.000732422 7.00579C-0.000732422 7.25968 0.0992969 7.50335 0.277686 7.68401C0.456075 7.86467 0.698458 7.96777 0.952329 7.97098L6.02718 7.97153L6.02718 13.0469C6.03039 13.3008 6.1335 13.5432 6.31416 13.7216C6.49481 13.9 6.73848 14 6.99237 14C7.24626 14 7.48993 13.9 7.67059 13.7216C7.85125 13.5432 7.95435 13.3008 7.95756 13.0469L7.95867 7.97153Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/Icon-plus.3fd02451.svg";
export { ForwardRef as ReactComponent };